import * as React from 'react';

function ManageProject(props) {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={24} height={24} viewBox='0 0 24 24' {...props}>
      <g id='Group_74' data-name='Group 74' transform='translate(-690 228)'>
        <rect
          id='Rectangle_18'
          data-name='Rectangle 18'
          width={24}
          height={24}
          transform='translate(690 -228)'
          fill='#fff'
        />
        <g id='_18._Fast_Delivery' data-name='18. Fast Delivery' transform='translate(683 -230)'>
          <path
            id='Path_22'
            data-name='Path 22'
            d='M18,6h4.785v4.091a.694.694,0,0,1-.694.694h-3.4A.694.694,0,0,1,18,10.091Z'
            transform='translate(-1.62 -0.203)'
            fill='#003ec4'
          />
          <path
            id='Path_23'
            data-name='Path 23'
            d='M25.152,22.544H12.392A2.392,2.392,0,0,1,10,20.152V7.392A2.392,2.392,0,0,1,12.392,5H25.152a2.392,2.392,0,0,1,2.392,2.392V20.152A2.392,2.392,0,0,1,25.152,22.544ZM12.392,6.595a.8.8,0,0,0-.8.8V20.152a.8.8,0,0,0,.8.8H25.152a.8.8,0,0,0,.8-.8V7.392a.8.8,0,0,0-.8-.8Z'
            fill='#003ec4'
          />
          <path
            id='Path_24'
            data-name='Path 24'
            d='M16.392,22.595H14.8A.8.8,0,1,1,14.8,21h1.595a.8.8,0,0,1,0,1.595Z'
            transform='translate(-0.81 -3.241)'
            fill='#003ec4'
          />
        </g>
      </g>
    </svg>
  );
}
export default ManageProject;
